import React from 'react';
import { styles } from './SearchResult.styles';
import { PropTypes } from 'prop-types';
import { Age, Gender } from '../../UI';
import { AddIcon } from '../../UI/Images/Icons';
import { useContext } from 'react';
import MessagesContext from '../../../contexts/messagesContext';
// import { createLoadingSelector } from '../../../redux/Loading/LoadingSelector';
// import * as type from '../../../redux/Patient/PatientType';
import patientFileIcon from '../../../assets/images/Icon/patientFile.svg';
import { getClinicId } from '../../../utils/storage';
import {
    loadMorePatients,
    setSelectedPatient,
    summonPatient
} from '../../../redux/Patient/PatientAction';
import { CircularProgress, Tooltip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useState } from 'react';

const Patient = ({ patient, goToPatientPage }) => {
    const classes = styles();
    const { messages } = useContext(MessagesContext);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const handleSelectPatient = (patient) => {
        goToPatientPage(patient);
        dispatch(setSelectedPatient(patient));
        // dispatch(clearPatients());
    };
    const isMemberOfClinic = (patient) => {
        const clinicId = getClinicId();
        return patient?.attending_clinics?.some((item) => item.id === clinicId);
    };
    const addPatientToClinic = async (patientId) => {
        const clinicId = getClinicId();
        setIsLoading(true);
        const response = await dispatch(summonPatient(patientId, clinicId));
        if (response.status >= 200 && response.status <= 300) {
            const params = {
                clinic: clinicId,
                offset: 0,
                limit: 20
            };
            dispatch(loadMorePatients(params));
        }
        setIsLoading(false);
    };
    return (
        <>
            <div className={classes.resultItem}>
                <div className={classes.row}>
                    <span>
                        {patient.first_name} {patient.last_name}
                    </span>
                    <div className={classes.overallInfo}>
                        {patient.gender && <Gender height="20" gender={patient.gender} />}
                        {patient.dob && <Age dob={patient.dob} />}
                    </div>
                </div>

                <div className={classes.tagsContainer}>
                    {patient?.attending_clinics?.map((clinic) => (
                        <span className={classes.tag} key={clinic.id}>
                            {clinic.name}
                        </span>
                    ))}
                </div>
                <>
                    {isLoading ? (
                        <div className={classes.patientLoading}>
                            <CircularProgress />
                        </div>
                    ) : !isMemberOfClinic(patient) ? (
                        <Tooltip
                            classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                            title={messages.summonPatientDesc}
                            arrow
                            placement={'bottom-start'}
                        >
                            <div
                                className={classes.linkWrapper}
                                onClick={() => addPatientToClinic(patient.id)}
                            >
                                <AddIcon color="#509ffa" />
                                <span className={classes.text}>{messages.summonPatient}</span>
                            </div>
                        </Tooltip>
                    ) : (
                        <Tooltip
                            classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                            title={messages.attendingClinicsDesc}
                            arrow
                            placement={'bottom-start'}
                        >
                            <div
                                className={classes.linkWrapper}
                                onClick={() => handleSelectPatient(patient)}
                            >
                                <img src={patientFileIcon} alt="patientFile" />
                                <span className={classes.text}>{messages.viewPatientFile}</span>
                            </div>
                        </Tooltip>
                    )}
                </>
            </div>
        </>
    );
};
Patient.propTypes = {
    patient: PropTypes.object,
    goToPatientPage: PropTypes.function
};
export default Patient;
